<template>
    <div class="permissions-editor">
        <ErrorsZone :errors="permissionsLoadingErrors"></ErrorsZone>
        <ErrorsZone :errors="permissionSettingErrors"></ErrorsZone>

        <table v-if="loadedOnce" id="permissionsTable" class="table table-bordered table-responsive table-hover">
            <thead>
            <tr>
                <th class="align-middle text-center">
                    <button class="btn btn-outline-secondary" @click="locked = !locked">
                        <i class="fas" :class="[locked ? 'fa-lock' : 'fa-unlock']"></i>
                        {{ locked ? 'Déverrouiller' : 'Verrouiller' }}
                    </button>
                </th>
                <template v-for="employee in employees">
                    <th v-if="!filteredEmployee || (employee.id === filteredEmployee.id)" class="text-center" scope="col">
                        <button
                            class="btn btn-sm btn-outline-secondary mb-2"
                            type="button"
                            :title="filteredEmployee ? 'Afficher tous les salariés' : 'Afficher uniquement ce salarié'"
                            @click="toggleFilteredEmployee(employee)"
                        >
                            <i class="fas" :class="[filteredEmployee && employee.id === filteredEmployee.id ? 'fa-arrows-h' : 'fa-filter']"></i>
                        </button>
                        <div>{{ employee.name }}</div>
                    </th>
                </template>
            </tr>
            </thead>
            <tbody>
            <template v-for="permissionGroup in permissions">
                <tr>
                    <th class="permission-group-name" scope="row" :colspan="employees.length + 1">{{ permissionGroup.name }}</th>
                </tr>
                <tr v-for="permission in permissionGroup.permissions">
                    <th class="permission-description" scope="row">{{ permission.description }}</th>
                    <template v-for="employee in employees">
                        <td v-if="!filteredEmployee || (employee.id === filteredEmployee.id)" class="text-center">
                            <button
                                v-if="hasPermission(employee, permission)"
                                class="btn-permission btn btn-success"
                                type="button"
                                :disabled="buttonsDisabled"
                                title="Action actuellement autorisée"
                                @click="removePermission(employee, permission)"
                            >
                                <i class="fad fa-check"></i>
                            </button>
                            <button
                                v-else
                                class="btn-permission btn btn-outline-danger"
                                type="button"
                                :disabled="buttonsDisabled"
                                title="Action actuellement refusée"
                                @click="addPermission(employee, permission)"
                            >
                                <i class="fad fa-times"></i>
                            </button>
                        </td>
                    </template>
                </tr>
            </template>
            </tbody>
        </table>
        <div v-else-if="loadingPermissions">
            <i class="fad fa-spinner"></i> Chargement des permissions...
        </div>
    </div>
</template>

<script>


import {useGetLoader} from "./compositions/axios/loadingRequest"
import ErrorsZone from "./ErrorsZone"
import {usePostRequest} from "./compositions/axios/postRequest"

export default {
    name: 'PermissionsEditor',
    components: {ErrorsZone},
    setup() {
        const {
            loading: loadingPermissions,
            loaded: permissionsLoaded,
            errors: permissionsLoadingErrors,
            load: loadPermissions,
        } = useGetLoader();

        const {
            loading: sendingPermission,
            loaded: permissionSent,
            errors: permissionSettingErrors,
            post: postPermission,
        } = usePostRequest();

        return {
            loadingPermissions,
            permissionsLoaded,
            permissionsLoadingErrors,
            loadPermissions,

            sendingPermission,
            permissionSent,
            permissionSettingErrors,
            postPermission,
        };
    },

    data() {
        return {
            employees: null,
            permissions: null,

            loadedOnce: false,

            locked: true,

            filteredEmployee: null,
        }
    },

    mounted() {
        this.loadState();
    },

    methods: {
        async loadState() {
            const response = await this.loadPermissions(`/espace-admin/permissions/json`);
            if (response && response.employees) {
                this.employees = response.employees;
                this.permissions = response.permissions;
            }
            this.loadedOnce = true;
        },

        addPermission(employee, permission) {
            this.setPermission(employee, permission, 1);
        },

        removePermission(employee, permission) {
            this.setPermission(employee, permission, 0);
        },

        async setPermission(employee, permission, state) {
            await this.postPermission(`/espace-admin/permissions/${employee.id}`, {
                permission: permission.name,
                state
            });
            await this.loadState();
        },

        hasPermission(employee, permission) {
            return !!employee.permissions.find(item => item.name === permission.name);
        },

        toggleFilteredEmployee(employee) {
            this.filteredEmployee = this.filteredEmployee ? null : employee
        },
    },

    computed: {
        buttonsDisabled() {
            return this.locked || this.sendingPermission || this.loadingPermissions;
        },
    },
}
</script>

<style>
.permission-group-name {
    background-color: #333333;
    color: #eeeeee;
    border: 1px solid #333333;
}

.permission-description {
    min-width: 300px;
}
</style>
